// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1IDOY","label":"Radio_label__2dNS6","checkMark":"Radio_checkMark__2ahAl","disabled":"Radio_disabled__1AxAa"};